export default "__VITE_ASSET__BwM_ErTK__"